import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { importLibrary, setOptions } from '@googlemaps/js-api-loader';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class GoogleMapsLoaderService {
  private ready?: Promise<void>;
  private platformId = inject(PLATFORM_ID);

  loadPlaces(): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) return Promise.resolve();
    if (!this.ready) {
      setOptions({
        key: environment.googleApiKey,
        v: 'weekly',
      });
      this.ready = importLibrary('places').then(() => undefined);
    }
    return this.ready;
  }
}
